/** @jsx jsx */
import { jsx } from "@emotion/core";
import { AlertErrorIcon } from "@smartsheet/lodestar-icons";
export var ErrorNode = function (_a) {
    var text = _a.text;
    return (jsx("div", { css: {
            display: "flex",
            alignItems: "center",
            fontSize: "13px",
            margin: "5px 0 5px 48px"
        } },
        jsx(AlertErrorIcon, { size: "small", css: { marginRight: "5px" } }),
        text));
};
//# sourceMappingURL=ErrorNode.js.map